import React, { useEffect, useRef } from "react";
import { Animated, View, Text } from "react-native";

export default function ActivationSuccess({
  color = 'white',
  textColor = 'white',
}) {
  const fadeAnim = useRef(new Animated.Value(0)).current;
  const slideAnim = useRef(new Animated.Value(-20)).current;

  useEffect(() => {
    Animated.parallel([
      Animated.timing(fadeAnim, {
        toValue: 1,
        duration: 500,
        useNativeDriver: true,
      }),
      Animated.timing(slideAnim, {
        toValue: 0,
        duration: 500,
        useNativeDriver: true,
      }),
    ]).start();
  }, []);

  return (
    <Animated.View
      style={{
        alignItems: "center",
        marginBottom: 12,
        opacity: fadeAnim,
        transform: [{ translateY: slideAnim }],
      }}
    >
      {/* Icon */}
      <View
        style={{
          width: 48,
          height: 48,
          borderRadius: 24,
          backgroundColor: color,
          justifyContent: "center",
          alignItems: "center",
          marginBottom: 8,
        }}
      >
        <Text style={{ color: "white", fontSize: 32 }}>✓</Text>
      </View>

      {/* Message */}
      <Text style={{ color: textColor, textAlign: "center" }}>
        Activation successful! Your plan and balances should appear soon.
      </Text>
    </Animated.View>
  );
}
